const POSITION = {
  up: 'up',
  down: 'down',
};

export const { up, down } = POSITION;
